module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMSIgaGVpZ2h0PSI5Ij4KICA8cGF0aCBmaWxsPSIjQUJCN0UxIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0xOS4wNjIgNC40N2wtMy41MjYtMi44MTVhLjUuNSAwIDAgMSAuNjI0LS43ODFsNC41NyAzLjY0OWEuNS41IDAgMCAxIC4wMDQuNzc5LjUwMi41MDIgMCAwIDEtLjE1Ni4xMThMMTYuMTUgOC43NzdhLjUuNSAwIDEgMS0uNjA0LS43OTdsMy4zMS0yLjUxSC41MDhhLjUuNSAwIDEgMSAwLTFoMTguNTU0eiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/images/link-arrow.svg
// module id = 669
// module chunks = 114276838955818